import { Stands, type StandsKeys } from '../Stands';

const juicyScoreKeys: Record<StandsKeys, string> = {
	[Stands.test]: '9LlT8siZDCwZweWpouifyfv8TEST',
	[Stands.cert]: '9aa6deGLIDqd7qkVo6bRdcAZTEST',
	[Stands.prod]: 'sLJSpWImGzdDzTXcdX3lx2yd',
};

const juicyScoreHosts: Record<StandsKeys, string> = {
	[Stands.test]: 'https://score.juicyscore.net',
	[Stands.cert]: 'https://score.juicyscore.net',
	[Stands.prod]: 'https://score.juicyscore.com',
};

const pixelHosts: Record<StandsKeys, string> = {
	[Stands.test]: 'https://pixel-demo.scoring.ru',
	[Stands.cert]: 'https://pixel-demo.scoring.ru',
	[Stands.prod]: 'https://pixel.scoring.ru',
};

const daDataKeys: Record<StandsKeys, string> = {
	[Stands.test]: '4e9721acd85d6d9d37144835a6d3ff17a9d340b5',
	[Stands.cert]: '4e9721acd85d6d9d37144835a6d3ff17a9d340b5',
	[Stands.prod]: '4e9721acd85d6d9d37144835a6d3ff17a9d340b5',
};

const captchaPublicKeys: Record<StandsKeys, string> = {
	[Stands.test]: 'ysc1_wQ5AuwMP2VjQS6H1DANGXKk5DFjIuYgAlDYnb7nz2089a78a',
	[Stands.cert]: 'ysc1_wQ5AuwMP2VjQS6H1DANGXKk5DFjIuYgAlDYnb7nz2089a78a',
	[Stands.prod]: 'ysc1_wQ5AuwMP2VjQS6H1DANGXKk5DFjIuYgAlDYnb7nz2089a78a',
};
const defaultAppConfigProps = {
	serviceWorkerVersion: '0.0.13',
};
export const defaultAppConfig = {
	[Stands.test]: {
		...defaultAppConfigProps,
		captchaPublicKey: captchaPublicKeys.test,
		daDataPublicKey: daDataKeys.test,
		juicyScoreKey: juicyScoreKeys.test,
		juicyScoreHost: juicyScoreHosts.test,
		pixelHost: pixelHosts.test,
	},
	[Stands.cert]: {
		...defaultAppConfigProps,
		captchaPublicKey: captchaPublicKeys.cert,
		daDataPublicKey: daDataKeys.cert,
		juicyScoreKey: juicyScoreKeys.cert,
		juicyScoreHost: juicyScoreHosts.cert,
		pixelHost: pixelHosts.cert,
	},
	[Stands.prod]: {
		...defaultAppConfigProps,
		captchaPublicKey: captchaPublicKeys.prod,
		daDataPublicKey: daDataKeys.prod,
		juicyScoreKey: juicyScoreKeys.prod,
		juicyScoreHost: juicyScoreHosts.prod,
		pixelHost: pixelHosts.prod,
	},
};
